import React, { useState, useEffect } from 'react';
import api from '../../services/api';

function NewsletterManagement() {
  const [newsletters, setNewsletters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({ subject: '', content: '', status: 'draft' });

  useEffect(() => {
    loadNewsletters();
  }, []);

  const loadNewsletters = async () => {
    try {
      const response = await api.get('/newsletters');
      setNewsletters(response.data.data || response.data || []);
    } catch (error) {
      console.error('Error loading newsletters:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post('/newsletters', formData);
      setShowModal(false);
      setFormData({ subject: '', content: '', status: 'draft' });
      loadNewsletters();
    } catch (error) {
      console.error('Error saving newsletter:', error);
    }
  };

  const handleSend = async (id) => {
    if (window.confirm('Send this newsletter?')) {
      try {
        await api.post(`/newsletters/${id}/send`);
        loadNewsletters();
      } catch (error) {
        console.error('Error sending newsletter:', error);
      }
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Delete this newsletter?')) {
      try {
        await api.delete(`/newsletters/${id}`);
        loadNewsletters();
      } catch (error) {
        console.error('Error deleting newsletter:', error);
      }
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold">Newsletters</h2>
        <button onClick={() => setShowModal(true)} className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700">Create Newsletter</button>
      </div>

      <div className="bg-white rounded-lg shadow overflow-hidden">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Subject</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Created</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {newsletters.map((n) => (
              <tr key={n.id}>
                <td className="px-6 py-4 whitespace-nowrap text-sm">{n.subject}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm">
                  <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${n.status === 'sent' ? 'bg-green-100 text-green-800' : n.status === 'scheduled' ? 'bg-blue-100 text-blue-800' : 'bg-gray-100 text-gray-800'}`}>{n.status}</span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm">{new Date(n.created_at).toLocaleDateString()}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                  {n.status !== 'sent' && <button onClick={() => handleSend(n.id)} className="text-green-600 hover:text-green-900 mr-3">Send</button>}
                  <button onClick={() => handleDelete(n.id)} className="text-red-600 hover:text-red-900">Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {newsletters.length === 0 && <div className="text-center py-8 text-gray-500">No newsletters found</div>}
      </div>

      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-white p-6 rounded-lg w-full max-w-lg">
            <h3 className="text-lg font-semibold mb-4">Create Newsletter</h3>
            <form onSubmit={handleSubmit} className="space-y-4">
              <input required placeholder="Subject" value={formData.subject} onChange={(e) => setFormData({ ...formData, subject: e.target.value })} className="w-full border rounded p-2" />
              <textarea required placeholder="Content" value={formData.content} onChange={(e) => setFormData({ ...formData, content: e.target.value })} className="w-full border rounded p-2" />
              <select value={formData.status} onChange={(e) => setFormData({ ...formData, status: e.target.value })} className="w-full border rounded p-2">
                <option value="draft">Draft</option>
                <option value="scheduled">Scheduled</option>
              </select>
              <div className="flex justify-end gap-3">
                <button type="button" onClick={() => setShowModal(false)} className="px-4 py-2 border rounded">Cancel</button>
                <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded">Save</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default NewsletterManagement;
